import { useEffect, useId, useState } from 'react'
import { useControls } from 'react-zoom-pan-pinch'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { libScaleForNative, toNativeScale } from '../helpers'

import * as S from './styles'

const ScaleBadge = ({ renderedWidth, naturalWidth }: ScaleBadgeProps) => {
  const { t } = useAPPTranslation()
  const { centerView, instance } = useControls()
  const scaleDescriptionId = useId()
  const [transformScale, setTransformScale] = useState(instance.state.scale)

  useEffect(
    () => instance.onChange(ref => setTransformScale(ref.state.scale)),
    [instance]
  )

  const label = t('c:components.CreativeZoom.zoomToNative')
  const formattedScale = `${toNativeScale(
    transformScale,
    renderedWidth,
    naturalWidth
  ).toFixed(2)}×`

  const handleZoomToNative = () => {
    const scale = libScaleForNative(renderedWidth, naturalWidth)

    if (scale == null) {
      return
    }

    centerView(scale)
  }

  return (
    <S.ScaleBadge
      type="button"
      data-testid="creative-zoom-scale"
      aria-label={label}
      aria-describedby={scaleDescriptionId}
      title={label}
      onClick={handleZoomToNative}
    >
      <span id={scaleDescriptionId}>{formattedScale}</span>
    </S.ScaleBadge>
  )
}

export default ScaleBadge
